<template>
  <div class="header">
    <div class="header-left">
      
      <h1 @click="changeCollapse" style="cursor: pointer">电仪EITPM决策管理平台</h1>
    </div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 全屏显示 -->
        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>
        <!-- 消息中心 -->
        <div class="btn-bell">
          <el-tooltip effect="dark" :content="message>0?`有${message}条未读消息`:`消息中心`" placement="bottom">
            <router-link to="/messageInfo">
              <i class="el-icon-bell"></i>
            </router-link>
          </el-tooltip>
          <span class="btn-bell-badge" v-if="message>0"></span>
        </div>
        <!-- 用户头像 -->
        <div class="user-avator"><img src="@/assets/images/avatar.jpg"></div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{username}} <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="userType == 'NORMAL'" command="updatePwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="passwordDialog" class="passDialog"  @close="closeDialog('passForm')">
      <el-form :model="passForm" :rules="passwordRules" ref="passForm" label-width="100px" status-icon>
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" v-model="passForm.oldPassword " autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="passForm.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="checkNewPass">
          <el-input type="password" v-model="passForm.checkNewPass" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="passwordDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitPassForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.passForm.checkNewPass !== "") {
          this.$refs.passForm.validateField("checkNewPass");
        }
        callback();
      }
    };
    var validatePass4 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      collapse: false,
      fullscreen: false,
      name: "admin",
      tableApi: "/notices",
      message: 0,
      userType: userInfo.type,
      userId: userInfo.id,
      passwordDialog: false,
      passForm: {
        oldPassword: "",
        newPassword: "",
        checkNewPass: ""
      },
      passId: "",
      passwordRules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, validator: validatePass3, trigger: "blur" }
        ],
        checkNewPass: [
          { required: true, validator: validatePass4, trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    username() {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      return userInfo ? userInfo.nickname : this.name;
    }
  },
  created() {
    this.getUnread();
    window.addEventListener("setItem", () => {
      this.message = sessionStorage.getItem("watchStorage");
    });
  },
  methods: {
    changeCollapse() {
      this.$emit("changeColl");
      // console.log("111");
    },
    getUnread() {
      let userId = JSON.parse(sessionStorage.getItem("userInfo")).id;
      this.$axios
        .get(`${this.tableApi}/unread`, {
          params: {
            userId: userId
          }
        })
        .then(res => {
          this.resetSetItem("watchStorage", res.data.data);
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == "loginout") {
        this.$axios
          .post(
            "users/logout",
            {},
            {
              // headers:{'Authorization':'Bearer '+auth}
            }
          )
          .then(res => {
            sessionStorage.removeItem("token");
            // sessionStorage.removeItem("userInfo");
            let loginWay = sessionStorage.getItem("loginWay");
            sessionStorage.removeItem("loginWay");
            if (window.siamEnabled && loginWay != "legacy") {
              location.href = window.siamLoginUrl;
            } else {
              this.$router.push("/login");
            }
          });
      }
      if (command == "updatePwd") {
        this.passwordDialog = true;
        this.passForm.oldPassword = this.passForm.newPassword = this.passForm.checkNewPass =
          "";
      }
    },
    submitPassForm() {
      const passData = {
        oldPassword: this.passForm.oldPassword,
        newPassword: this.passForm.newPassword
      };
      this.$refs["passForm"].validate(valid => {
        if (valid) {
          this.$axios
            .put(`/users/${this.userId}/password`, passData)
            .then(res => {
              this.$message.success("修改成功");
              this.passwordDialog = false;
            })
            .catch(err => {
              console.log(err.response.data);
              this.$message.error(err.response.data.message);
              this.passwordDialog = false;
            });
        }
      });
    },
    closeDialog() {
      this.$refs["passForm"].resetFields();
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    }
  }
};
</script>
<style lang="scss">
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 70px;
  font-size: 22px;
  color: #fff;
  background-color: #242f42;
}
.header-left {
  float: left;
  img {
    width: 40px;
    padding-top: 15px;
    float: left;
    margin-left: 12px;
  }
  h1 {
    font-size: 20px;
    font-weight: 500;
    line-height: 70px;
    padding-left: 60px !important;
    white-space: nowrap;
    color: #fff;
  }
}
.header-right {
  float: right;
  padding-right: 50px;
}
.header-user-con {
  display: flex;
  height: 70px;
  align-items: center;
}
.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}
.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}
.btn-bell .el-icon-bell {
  color: #fff;
}
.user-name {
  margin-left: 10px;
}
.user-avator {
  margin-left: 20px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}
.el-dropdown-menu__item {
  text-align: center;
}

.passDialog > .el-dialog {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/HeadBar.vue